module.exports = __webpack_public_path__ + "media/images/brand/logo-74406f16e21837daacb07cae79e90ba3.png";